import { Attachment, LocalMessage } from 'stream-chat';

function sortPinnedMessagesByRecency(
  pinnedMessages: LocalMessage[],
): LocalMessage[] {
  return [...pinnedMessages].sort((a, b) => {
    const aTime = a.pinned_at ? new Date(a.pinned_at).getTime() : 0;
    const bTime = b.pinned_at ? new Date(b.pinned_at).getTime() : 0;
    return bTime - aTime;
  });
}

export function getLatestPinnedMessage(
  pinnedMessages: LocalMessage[] | undefined,
): LocalMessage | null {
  if (!pinnedMessages?.length) {
    return null;
  }

  return sortPinnedMessagesByRecency(pinnedMessages)[0];
}

export function getStalePinnedMessages(
  pinnedMessages: LocalMessage[] | undefined,
): LocalMessage[] {
  if (!pinnedMessages || pinnedMessages.length <= 1) {
    return [];
  }

  return sortPinnedMessagesByRecency(pinnedMessages).slice(1);
}

function getAttachmentPreview(attachment: Attachment): string {
  const type = attachment.type?.toLowerCase();

  if (type === 'giphy' || attachment.giphy) {
    return '👾 GIF';
  }
  if (type === 'image' || attachment.image_url) {
    return '📷 Image';
  }
  if (
    type === 'audio' ||
    type === 'voice' ||
    attachment.waveform_data?.length ||
    attachment.mime_type?.startsWith('audio/')
  ) {
    return '🎤 Voice Message';
  }
  if (type === 'video' || attachment.mime_type?.startsWith('video/')) {
    return '📹 Video';
  }

  return '📎 Attachment';
}

export function getPinnedMessagePreviewText(message: LocalMessage): string {
  const text = message.text?.trim();
  if (text) {
    return text;
  }

  if (message.poll) {
    return `📊 ${message.poll?.name ?? 'Poll'}`;
  }

  const attachments = message.attachments ?? [];
  if (attachments.length > 0) {
    return getAttachmentPreview(attachments[0]);
  }

  return 'Message';
}

export function canUnpinPinnedMessage(
  channelCapabilities: Record<string, boolean> | undefined,
): boolean {
  return !!channelCapabilities?.['pin-message'];
}
